import React from 'react';
import {Bar} from 'react-chartjs-2';
import moment from 'moment';

const ChartSmall = ({datesData, SmaDataPositive, SmaDataNeutral, SmaDataNegative, fetchEntityCSVFile}) => {
    const convertDateArr = (dateArr) => {
        let dateArrClone = [...dateArr];
        let initialMonth = dateArrClone[0].split(' ')[1];
        dateArrClone.forEach((item, index) => {
            let singleDateAsArray = item.split(' ');
            if(singleDateAsArray[0].length === 1) singleDateAsArray[0] = `0${singleDateAsArray[0]}`;
            dateArrClone[index] = singleDateAsArray[0];
            if(index === 0) {
                dateArrClone[index] = singleDateAsArray[1];
            } else if(index % 2 === 0) {
                if(singleDateAsArray[1] !== initialMonth) {
                    dateArrClone[index] = singleDateAsArray[1];
                    initialMonth = singleDateAsArray[1];
                } else {
                    dateArrClone[index] = singleDateAsArray[0];
                }
            } else {
                dateArrClone[index] = '';
            }
        });
        return dateArrClone;
    };

    const data = {
        labels: convertDateArr(datesData),//datesData.map(item => convertDateString(item)),//datesData.map((item, index) => index % 5 === 0 ? item : '' ),
        datasets: [
            {
                label: 'SMA Positive',
                data: SmaDataPositive,
                borderColor: '#2eb85c',
                backgroundColor: '#2eb85c',
                fill: false,
                type: 'line',
                datalabels: {
                    display: false,
                },
            },
            {
                label: 'SMA Neutral',
                data: SmaDataNeutral,
                borderColor: '#ced2d8',
                backgroundColor: '#ced2d8',
                fill: false,
                type: 'line',
                datalabels: {
                    display: false,
                },
            },
            {
                label: 'SMA Negative',
                data: SmaDataNegative,
                borderColor: '#e55353',
                backgroundColor: '#e55353',
                fill: false,
                type: 'line',
                datalabels: {
                    display: false,
                },
            },
        ],
    };

    const options = {
        legend: {
            display: true,
        },
        tooltips: {
            callbacks: {
                title: tooltipItem => datesData[tooltipItem[0].index],
            },
        },
        maintainAspectRatio: false,
        scales: {
            xAxes: [
                {
                    ticks: {
                        autoSkip: false,
                        maxTicksLimit: 15,
                        stepSize: 1,
                    },
                },
            ],
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
        plugins: {
            datalabels: {
                display: true,
                color: 'white',
                borderRadius: 6,
                font: {
                    size: 12,
                },
                formatter: function(value) {
                    if(value > 0) {
                        return value;
                    } else {
                        return null;
                    }
                },
            },
        },
    };

    return (
        <div className="d-flex flex-column" style={{flex: 1, paddingTop: '10px'}}>
            <div className="d-flex justify-content-between align-items-center">
                <div className="entity-chart-title">Sentiments (5 Day SMA)</div>
                <div
                    className="chart-open-button d-flex align-items-center justify-content-center"
                    onClick={fetchEntityCSVFile}
                    title="Sentiment Analysis for 30 days"
                    style={{height: '30px'}}
                >
                    {/*<i className="fas fa-download"/>&nbsp;*/}
                    {/*Download CSV*/}
                    <i className="fas fa-download"/>
                </div>
            </div>
            <div style={{
                maxHeight: '300px',
                padding: '15px 0 10px',
                marginBottom: '10px',
                flex: 1,
            }}>
                <Bar
                    data={data}
                    height={300}
                    responsive={false}
                    options={options}
                />
            </div>
        </div>
    );
};


export default ChartSmall;
